export default "__VITE_ASSET__cqcVEzl6__"